var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    { attrs: { name: "photo-delete-modal", pivotY: 0.2, height: "auto" } },
    [
      _c("div", { staticClass: "modal-close-btn-point" }, [
        _c(
          "div",
          {
            staticClass: "modal-close-btn-container",
            on: {
              click: function($event) {
                return _vm.hideModal("photo-delete-modal")
              }
            }
          },
          [_c("SVGModalClose")],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-title-big" }, [
        _vm._v("\n        Удалить фотографии\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-text" }, [
        _vm._v("\n        Удалить выбранные фото из проекта?\n    ")
      ]),
      _vm._v(" "),
      _c(
        "vue-custom-scrollbar",
        { staticClass: "modal-photo-carousel" },
        _vm._l(_vm.selectedPhotos, function(img, key) {
          return _c("div", [
            _c("img", {
              staticClass: "modal-photo-carousel-element",
              attrs: { src: _vm.urlForFileStorage(img.src) }
            })
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-button", on: { click: _vm.removePhotos } },
        [_vm._v("\n        Удалить\n    ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }